<template>
  <nav>
    <div v-if="smallScreen" class="header-mobile">
      <f-menu-toggle @click="toggleMenu" :menuOpen="menuOpen" />

      <h1>{{ $t("title") }}</h1>

      <f-locale-changer />
    </div>

    <div class="menu-links" :class="{ open: menuOpen }">
      <router-link @click.native="toggleMenu" to="/" exact>Home</router-link>
      <router-link @click.native="toggleMenu" to="about">{{
        $t("about.title")
      }}</router-link>
      <router-link @click.native="toggleMenu" to="foundation">{{
        $t("foundation.title")
      }}</router-link>
      <router-link @click.native="toggleMenu" to="guidelines">{{
        $t("guidelines.title")
      }}</router-link>

      <f-locale-changer v-if="!smallScreen"></f-locale-changer>
    </div>
  </nav>
</template>

<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
import LocaleChanger from "@/components/Buttons/LocaleChanger.vue";
import MenuToggle from "@/components/Buttons/MenuToggle.vue";

export default {
  name: "navigation",
  components: {
    "f-locale-changer": LocaleChanger,
    "f-menu-toggle": MenuToggle,
  },
  data() {
    return {
      active: this.$store.state.activeUser,
      menuOpen: false,
    };
  },
  methods: {
    clicked(location) {
      this.menuOpen = false;
      this.navigate(location);
    },
    toggleMenu: function () {
      this.menuOpen = !this.menuOpen;
    },
  },
};
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss" scoped>
nav {
  position: relative;
}

/* mobile menu */
@include max-medium {
  .header-mobile {
    position: fixed;
    top: -1px;
    left: 0;
    right: 0;
    @include flex(space-between);
    padding: 15px 8px 15px 6px;
    background-color: white;
    @include nav-shadow;
    z-index: 30;

    h1 {
      font-size: 20px;
      margin-top: 0;
      padding-top: 0;
    }
  }

  .menu-links {
    background-color: white;
    position: fixed;
    top: -4px;
    left: 0;
    right: 0;
    text-align: center;
    margin-top: $header-height;
    /* closed styling */
    padding: 0;
    height: 0;
    z-index: 20;
    overflow: hidden;

    // @include marion-background(.4, .5);

    &:after {
      content: "";
      @include pos-absolute-full;
      background-color: $green-3;
      // background-color: aliceblue;
      opacity: 0.2;
      z-index: -1;
    }

    &.open {
      height: 300px;
      padding-top: 20px;
      padding-bottom: 20px;
      @include nav-shadow;
    }

    a {
      display: block;
      padding: 20px;
      font-size: 1em;

      &:hover {
        background-color: rgba(59, 127, 122, 0.25);
      }
    }
  }
}

/* desktop menu */
@include min-large {
  .menu-links {
    padding: 20px 80px;

    a {
      padding: 12px 18px;
      font-size: 1em;
      font-weight: 500;
      letter-spacing: 1.6px;
      color: $dark-green;
      border-top: 1px solid transparent;

      &:hover {
        border-top-color: $bright-green;
        border-top-color: $green-2;
      }
    }

    .router-link-exact-active {
      border-top-color: $dark-green;
    }

    @include flex(space-around);
    @include maxWidthCenter;
  }

  .locale-changer {
    position: absolute;
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
